module.exports = __webpack_public_path__ + "img/icono_whatsapp.c65dee23.png";